<template>
  <div :class="[$style.base, { [$style.cardStyle]: cardStyle }]">
    <div
      :class="$style.title"
      @click="$emit('toggle', $el)"
      v-test="'accordionItemTitle'"
    >
      <BaseIcon :name="`arrow-${isOpen ? 'up' : 'down'}`" />
      <BaseHeading size="m">{{ title }}</BaseHeading>
      <BaseLabel
        v-if="label"
        :state="label"
        v-test="'accordionItemLabel'"
      />
    </div>
    <div
      v-show="isOpen"
      :class="$style.content"
      v-test="'accordionItemContent'"
    >
      <slot />
    </div>
  </div>
</template>

<script
  lang="ts"
  setup
>
withDefaults(
  defineProps<{
    title: string;
    isOpen?: boolean;
    cardStyle?: boolean;
    label?: string | null;
  }>(),
  {
    isOpen: false,
    cardStyle: false,
  },
);

defineEmits(['toggle']);
</script>

<style
  lang="scss"
  module
>
.base {
  border-bottom: 1px solid var(--border);

  &:first-child {
    border-top: 1px solid var(--border);
  }

  &.cardStyle {
    border: 1px solid var(--border);
    border-radius: $radius;
    background-color: var(--surface-primary);
  }
}

.title {
  display: flex;
  align-items: center;
  gap: $spacing * .5;
  padding: $spacing;

  @include hover {
    cursor: pointer;
    background-color: var(--highlight);
  }

  .base.cardStyle & {
    @include hover {
      background-color: transparent;
    }
  }
}

.content {
  padding: $spacing;
}
</style>
